import React, {useEffect, useState} from 'react';
import Modal from 'react-modal';
import {Link} from "react-scroll";
import TimelineProcess from "./Timeline/TimelineProcess";
import Sectitle from "./Title/Sectitle";

Modal.setAppElement('#root');
const HostingActionTwo = () => {
    const [modalIsOpen, setModalIsOpen ] = useState(false);

    useEffect(() => {
        if(modalIsOpen){
            document.body.style.overflow = 'hidden';
        }
        else {
            document.body.style.overflow = 'unset';
        }
    });

    const handleOpenModal = () => {
        setModalIsOpen(true)
    }

    return (
        <section id="milestones">
            <br/>
            <br/>
            <br/>
            <Sectitle Title="Milestones." TitleP="The phases of our project towards the final goal."
                      sClass="sec_title text-center mb_70"/>
            <div className="h_action_promo_area">
                <div className="overlay_bg"
                     style={{backgroundImage: "url(" + (require("../img/hosting/hosting_action_bg.png")) + ")"}}/>
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-md-8">
                            <div className="h_promo_content">
                                <h2>Our journey of GreenHubLK!</h2>
                                <p>The inner circle.</p>
                            </div>
                        </div>
                        <div className="col-md-4 text-right">

                            <Link className="nav-link" activeClass="active" to="home" ><button className="hosting_btn btn_hover" onClick={handleOpenModal} >
                                View Progress Timeline
                            </button></Link>
                            <Modal
                                isOpen={modalIsOpen}
                                onRequestClose={()=> setModalIsOpen(false)}
                                contentLabel="Progress"
                            >
                                <TimelineProcess />
                                <button className="btn btn-danger" onClick={()=> setModalIsOpen(false)}>Close</button>
                            </Modal>
                        </div>

                    </div>
                </div>
            </div>

            <br/>

        </section>
    )
}

export default HostingActionTwo;
